<div class="error-message-modal">
	<h1>{{ header | translate }} </h1>
	<div role="button"
		class="close-btn"
		id="{{closeButtonId}}"
		(click)="onCloseClick($event)">
		<img [src]=" 'assets/icons/Close.svg' | svgInline | async"
			alt=""
			srcset="">
	</div>
	<p role="text"
		class="description">
		{{ description | translate }}
	</p>
	<div class="d-flex">
		<div class="ml-0 mr-4 pl-0">
			<vtr-ui-button
				(onClick)="onCloseClick($event)"
				[title]="closeText | translate"
				[label]="closeText | translate"
				[linkId]="cancelButtonId">
			</vtr-ui-button>
		</div>
	</div>
</div>
